const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/* ============================================================
   LEGACY LOGIN
============================================================ */

export async function sendAccessCode(email) {
  const res = await fetch(`${API_BASE_URL}send-access-code`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ email })
  });

  const data = await res.json();

  if (!res.ok || !data.success) {
    throw new Error(data.error || "Failed to send access code");
  }

  return data;
}

export async function checkAccess(email, accessCode) {
  const res = await fetch(`${API_BASE_URL}check-login-access`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      email,
      accessCode
    })
  });

  const data = await res.json();

  if (!res.ok || !data.success) {
    throw new Error(data.error || "Invalid or expired code");
  }

  return data;
}

/* ============================================================
   USER VALIDATION
============================================================ */

export async function getUser(userId, email) {
  const res = await fetch(`${API_BASE_URL}check-user-credentials`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      userId,
      email
    })
  });

  const data = await res.json();

  if (!res.ok || !data.success) {
    throw new Error(data.error || "Unable to load user.");
  }

  return data.user;
}

export async function checkUser(email) {
  const res = await fetch(`${API_BASE_URL}check-user-credentials`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      email
    })
  });

  const data = await res.json();

  if (!res.ok || !data.success) {
    const error = new Error(data.error || "Access not allowed.");
    error.status = res.status;
    error.code = data.code || null;
    throw error;
  }

  return data;
}

export async function completeCompanySetup(companyName, email, setupToken) {
  const res = await fetch(`${API_BASE_URL}complete-company-setup`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      companyName: String(companyName || "").trim(),
      email: String(email || "").toLowerCase().trim(),
      setupToken
    })
  });

  const data = await res.json();

  if (!res.ok || !data.success) {
    throw new Error(data.error || "Unable to complete company setup.");
  }

  return data;
}

export async function requestAccess(name, email) {
  const res = await fetch(`${API_BASE_URL}request-access`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      name: String(name || "").trim(),
      email: String(email || "").toLowerCase().trim()
    })
  });

  const contentType = res.headers.get("content-type") || "";
  let data = null;

  if (contentType.includes("application/json")) {
    data = await res.json();
  } else {
    // Express/Heroku can return an HTML 404 page when the backend route is not deployed yet.
    // Consume it safely instead of exposing a JSON parse error in the modal.
    await res.text();
  }

  if (!res.ok || !data?.success) {
    let message = data?.error || "Unable to submit access request.";

    if (res.status === 404 && !data) {
      message = "Access requests are temporarily unavailable. Please try again shortly.";
    }

    const error = new Error(message);
    error.status = res.status;
    error.code = data?.code || null;
    throw error;
  }

  return data;
}

/* ============================================================
   PORTAL LOGIN
============================================================ */

export async function portalCheckEmail(email) {
  const res = await fetch(`${API_BASE_URL}portal/check-email`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      email: email.toLowerCase().trim()
    })
  });

  const data = await res.json();

  if (!res.ok || !data.success) {
    throw new Error(data.error || "Unable to verify this email.");
  }

  return data;
}

export async function portalSendAccessCode(companyName, email) {
  const res = await fetch(`${API_BASE_URL}portal-send-access-code`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      companyName,
      email: email.toLowerCase().trim()
    })
  });

  const data = await res.json();

  if (!res.ok || !data.success) {
    throw new Error(data.error || "Failed to send access code.");
  }

  return data;
}

export async function portalCheckAccessCode(companyName, email, accessCode) {
  const res = await fetch(`${API_BASE_URL}portal-check-access-code`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      companyName,
      email: email.toLowerCase().trim(),
      accessCode
    })
  });

  const data = await res.json();

  if (!res.ok || !data.success) {
    throw new Error(data.error || "Invalid or expired code.");
  }

  return data;
}